export default __webpack_public_path__ + "static/media/Angelz.d106a244.png";